import { Heart, Mail } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "../lib/scroll";

const LINKS = [
  { label: "The Pack", href: "#pack" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "Cotton Refills", href: "#cotton" },
  { label: "Comfort Range", href: "#range" },
  { label: "Shop", href: "#shop" },
  { label: "Retailers", href: "#retailers" },
  { label: "Safety & Testing", href: "#safety" },
  { label: "Safer Sleep", href: "#safer-sleep" },
  { label: "Register Interest", href: "#register" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-binky-blue/10 bg-white">
    <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
        <div>
          <Logo />
          <p className="mt-4 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs font-bold uppercase tracking-[0.2em] text-slate-400">
            <span>Comfort</span>
            <Heart className="h-3 w-3 fill-binky-pink text-binky-pink" />
            <span>Innovation</span>
            <Heart className="h-3 w-3 fill-binky-pink text-binky-pink" />
            <span>Designed in Britain</span>
          </p>
          <a
            data-testid="footer-email-link"
            href="mailto:info@binky.life"
            className="mt-4 inline-flex items-center gap-2 rounded-full bg-binky-pinklight px-5 py-2.5 text-sm font-bold text-binky-pink transition-transform duration-300 hover:scale-105"
          >
            <Mail className="h-4 w-4" />
            info@binky.life
          </a>
        </div>
        <nav className="flex flex-wrap gap-x-7 gap-y-3" data-testid="footer-links">
          {LINKS.map((l) => (
            <button
              key={l.href}
              data-testid={`footer-link-${l.href.slice(1)}`}
              onClick={() => scrollToId(l.href)}
              className="text-sm font-semibold text-slate-500 transition-colors hover:text-binky-pink"
            >
              {l.label}
            </button>
          ))}
        </nav>
      </div>
      <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-slate-100 pt-8 md:flex-row md:items-center">
        <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
          <p className="text-xs font-semibold text-slate-400" data-testid="footer-copyright">
            © 2026 BINKY.LIFE — Mi Binky Comfort System. All rights reserved. Patent Pending.
          </p>
          <button
            data-testid="footer-cookie-settings"
            onClick={() => window.dispatchEvent(new Event("mibinky:cookie-settings"))}
            className="text-xs font-semibold text-slate-400 underline decoration-binky-pink/30 underline-offset-4 transition-colors hover:text-binky-pink"
          >
            Cookie Settings
          </button>
        </div>
        <p className="max-w-xl text-[11px] leading-relaxed text-slate-400" data-testid="footer-disclaimer">
          Mi Binky is currently in pre-launch. The product design is undergoing independent
          conformity testing; final instructions and claims will reflect the completed testing.
        </p>
      </div>
    </div>
  </footer>
);
